import React from 'react'
import { Col, Form, Row } from 'antd'
import { Formik } from 'formik'
import { useTranslation } from 'react-i18next'
import { Button, Drawer } from 'src/components/Ant'
import { Input, InputNumber, Select } from 'src/components/Formik'
import { DrawerOrganizationForm, emptyDrawerValues } from './initial-values'
import { validationDrawerSchema } from './validation-schema'
import * as CSS from './styles'
import TenantAddress from './address'

type Props = {
  onSubmit(values: DrawerOrganizationForm): void
  refFormik: React.MutableRefObject<Formik<DrawerOrganizationForm>>
}

export default function TenantDrawer({ refFormik, onSubmit }: Props) {
  const { t } = useTranslation()

  return (
    <Formik
      initialValues={emptyDrawerValues}
      onSubmit={onSubmit}
      ref={refFormik}
      render={formikProps => (
        <Drawer
          footer={
            <CSS.DrawerFooterDiv>
              <Button
                onClick={() => {
                  formikProps.resetForm(emptyDrawerValues)
                }}
                title="common.actions.cancel"
                type="default"
              />
              <CSS.Button
                onClick={() => {
                  formikProps.submitForm()
                }}
                title="common.actions.save"
                type="primary"
              />
            </CSS.DrawerFooterDiv>
          }
          onClose={() => {
            formikProps.resetForm(emptyDrawerValues)
          }}
          title={t('common.actions.new')}
          visible={Boolean(formikProps.values?.organization_id)}
          width={600}
        >
          <Form onSubmit={formikProps.handleSubmit}>
            <Row gutter={24}>
              <Col span={11}>
                <Input
                  formikProps={formikProps}
                  label="web.resources.common.code.title"
                  name="code"
                />
              </Col>
              <Col offset={2} span={11}>
                <Input
                  formikProps={formikProps}
                  label="web.organization.vat-number"
                  name="vat_number"
                />
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={11}>
                <Input
                  formikProps={formikProps}
                  label="web.organization.legal-name"
                  name="legal_name"
                />
              </Col>
              <Col offset={2} span={11}>
                <Input
                  formikProps={formikProps}
                  label="web.organization.trade-name"
                  name="trade_name"
                />
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={11}>
                <Select
                  dataTestId="organization-type"
                  formikProps={formikProps}
                  label="web.organization.type"
                  name="organization_type"
                  options={[
                    {
                      label: 'HOLDING',
                      title: 'HOLDING',
                      value: 'HOLDING'
                    },
                    {
                      label: 'SUBSIDIARY',
                      title: 'SUBSIDIARY',
                      value: 'SUBSIDIARY'
                    }
                  ]}
                />
              </Col>
              <Col offset={2} span={11}>
                <InputNumber
                  dataTestId="user-limit"
                  formikProps={formikProps}
                  label="web.user.title"
                  name="user_limit"
                />
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <Input
                  formikProps={formikProps}
                  label="web.user.common.email.title"
                  name="email"
                />
              </Col>
              <Col span={12}>
                <Input
                  formikProps={formikProps}
                  label="web.user.common.phone_number.title"
                  name="phone_contact"
                />
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={24}>
                <TenantAddress formikProps={formikProps} />
              </Col>
            </Row>
          </Form>
        </Drawer>
      )}
      validationSchema={validationDrawerSchema}
    />
  )
}
